import {
  PCMS_AMDSM_REQUEST,
  PCMS_AMDSM_SUCCESS,
  PCMS_AMDSM_FAILURE,
  PCMS_SOT_REQUEST,
  PCMS_SOT_SUCCESS,
  PCMS_SOT_FAILURE,
  PCMS_CARE_ASSIST_LOADING,
  PCMS_CARE_ASSIST_SUCCESS,
  PCMS_CARE_ASSIST_FAILURE,
  PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_LOADING,
  PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_SUCCESS,
  PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_FAILURE,
  PCMS_DETAILS_REQUEST,
  PCMS_DETAILS_SUCCESS,
  PCMS_DETAILS_FAILURE,
  PCMS_FILTER_DATA_REQUEST,
  PCMS_FILTER_DATA_SUCCESS,
  PCMS_FILTER_DATA_FAILURE,
  PCMS_FILTER_DATA_LOADING,
} from '@src/middleware/actions/actionTypes';

interface PreCheckMyScriptReducerState {
  AMDSMDDetails: any;
  AMDSMDIsLoading: boolean;
  AMDSMDDetailsError: string | null;
  SOTDetails: any;
  SOTIsLoading: boolean;
  SOTDetailsError: string | null;
  CareAssistData: any;
  CareAssistIsLoading: boolean;
  CareAssistDataError: string | null;
  CareAssistTaxIdActivationData: any;
  CareAssistTaxIdActivationIsLoading: boolean;
  CareAssistTaxIdActivationDataError: string | null;
  pcmsTableDetails: any;
  pcmsTableDetailsLoading: boolean;
  pcmsTableDetailsError: string | null;
  filterDetails: any;
  filterDetailsIsLoading: boolean;
  filterDetailsError: string | null;
}

const initialState: PreCheckMyScriptReducerState = {
  AMDSMDDetails: {},
  AMDSMDIsLoading: false,
  AMDSMDDetailsError: null,
  SOTDetails: {},
  SOTIsLoading: false,
  SOTDetailsError: null,
  CareAssistData: {},
  CareAssistIsLoading: false,
  CareAssistDataError: null,
  CareAssistTaxIdActivationData: {},
  CareAssistTaxIdActivationIsLoading: false,
  CareAssistTaxIdActivationDataError: null,
  pcmsTableDetails: {},
  pcmsTableDetailsLoading: false,
  pcmsTableDetailsError: null,
  filterDetails: null,
  filterDetailsIsLoading: false,
  filterDetailsError: null,
};

const PreCheckMyScriptReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PreCheckMyScriptReducerState => {
  switch (action.type) {
    case PCMS_AMDSM_REQUEST:
      return {
        ...state,
        AMDSMDIsLoading: true,
        AMDSMDDetailsError: null,
      };

    case PCMS_AMDSM_SUCCESS:
      return {
        ...state,
        AMDSMDDetails: action.payload,
        AMDSMDIsLoading: false,
        AMDSMDDetailsError: null,
      };

    case PCMS_AMDSM_FAILURE:
      return {
        ...state,
        AMDSMDDetailsError: action.payload,
        AMDSMDIsLoading: false,
      };

    case PCMS_SOT_REQUEST:
      return {
        ...state,
        SOTIsLoading: true,
        SOTDetailsError: null,
      };

    case PCMS_SOT_SUCCESS:
      return {
        ...state,
        SOTDetails: action.payload,
        SOTIsLoading: false,
        SOTDetailsError: null,
      };

    case PCMS_SOT_FAILURE:
      return {
        ...state,
        SOTDetailsError: action.payload,
        SOTIsLoading: false,
      };
     
    case PCMS_CARE_ASSIST_LOADING:
      return {
        ...state,
        CareAssistIsLoading: action.payload,
        CareAssistDataError: action.payload ? null : state.CareAssistDataError,
      };
    case PCMS_CARE_ASSIST_SUCCESS:
      return {
        ...state,
        CareAssistData: action.payload,
        CareAssistDataError: null,
      };
    case PCMS_CARE_ASSIST_FAILURE:
      return {
        ...state,
        CareAssistDataError: action.payload,
      };
     
    case PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_LOADING:
      return {
        ...state,
        CareAssistTaxIdActivationIsLoading: action.payload,
        CareAssistTaxIdActivationDataError: action.payload ? null : state.CareAssistTaxIdActivationDataError,
      };
    case PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_SUCCESS:
      return {
        ...state,
        CareAssistTaxIdActivationData: action.payload,
        CareAssistTaxIdActivationDataError: null,
      };
    case PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_FAILURE:
      return {
        ...state,
        CareAssistTaxIdActivationDataError: action.payload,
      };
      case PCMS_DETAILS_REQUEST:
        return {
          ...state,
          pcmsTableDetailsLoading: true,
          pcmsTableDetailsError: null,
        };
  
      case PCMS_DETAILS_SUCCESS:
        return {
          ...state,
          pcmsTableDetails: action.payload,
          pcmsTableDetailsLoading: false,
          pcmsTableDetailsError: null,
        };
  
      case PCMS_DETAILS_FAILURE:
        return {
          ...state,
          pcmsTableDetailsError: action.payload,
          pcmsTableDetailsLoading: false,
        };

      case PCMS_FILTER_DATA_REQUEST:
        return {
          ...state,
          filterDetailsIsLoading: true,
          filterDetailsError: null,
        };

      case PCMS_FILTER_DATA_LOADING:
        return {
          ...state,
          filterDetailsIsLoading: action.payload,
        };

      case PCMS_FILTER_DATA_SUCCESS:
        return {
          ...state,
          filterDetails: action.payload,
          filterDetailsIsLoading: false,
          filterDetailsError: null,
        };

      case PCMS_FILTER_DATA_FAILURE:
        return {
          ...state,
          filterDetailsError: action.payload,
          filterDetailsIsLoading: false,
        };

    default:
      return state;
  }
};

export default PreCheckMyScriptReducer;
